export class AppConfig {
  API_URL: string;
  STAGE: string;
}
